import { gql } from '@apollo/client';

export const UPDATE_GENERIC_DICTIONARY_ITEMS = gql`
  mutation updateGenericDictionaryItems($input: GenericDictionaryItemsInput) {
    updateGenericDictionaryItems(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_DICTIONARY_ITEMS = gql`
  mutation updateDictionaryItems($input: DictionaryItemsInput) {
    updateDictionaryItems(input: $input) {
      commandId
      correlationId
    }
  }
`;
